import {
  withTranslation,
} from 'react-i18next';

import ChampionshipSponsorsSectionView from './ChampionshipSponsorsSectionView';

const TranslatedComponent = withTranslation()(ChampionshipSponsorsSectionView);

const Component = TranslatedComponent;

export default Component;
